<template>
	<div>
		<!-- Tab Selector -->
		<div id="product-details"></div>
		<Tabs
			:tabs="tabs"
			v-if="tabs.length > 1"
			@TabSelection="setTabIndex"
			:selected="$store.state.ecommerce.detailsTab"
			name="details-tab"
			class="margin-bottom-2xl"
		></Tabs>

		<!-- Tabs -->
		<div class="details-container">
			<ProductDescription
				v-if="isActiveTab('Beskrivelse')"
				:static-title="content.title"
				:static-description="content.description"
			/>
			<ProductAttributes v-if="isActiveTab('Spesifikasjoner')" />
			<AboutSwap
				id="swap-tab"
				v-if="isActiveTab(content.swapTabtitle)"
				:cards="content?.cards"
				:drop-downs="content?.dropDowns"
				:heading="content.swapContentHeading"
				:movie-title="content.swapContentMovieTitle"
				:movie-url="content.swapContentMovieURL"
				:show-swap-movie="content.showSWAPmovie"
			/>
			<ProductReviews v-if="isActiveTab('Kundevurderinger')" />
		</div>
	</div>
</template>

<script>
import GizmoComponentMixin from "~/mixins/platform/GizmoComponentMixin.js";
import ECommerceProductMixin from "../ECommerceProductMixin/ECommerceProductMixin.js";
import { mapState } from "vuex";

export default defineNuxtComponent({
	name: "ECommerceProductDetails",
	mixins: [ECommerceProductMixin, GizmoComponentMixin],

	data() {
		return {
			tabIndex: 0,
		};
	},

	computed: {
		...mapState("ecommerce", ["product"]),
		isSwappable() {
			return this.product?.swapTotalPrice;
		},
		tabs() {
			const base = ["Beskrivelse"];
			if (!this.content.hideSpecs && this.product.attributes) base.push("Spesifikasjoner");
			if (!this.content.hideSwap && this.isSwappable) base.push(this.content.swapTabtitle);
			if (!this.content.hideReviews && this.product.bazaarVoiceId) {
				base.push("Kundevurderinger");
			}
			return base;
		},
	},

	methods: {
		setTabIndex(event) {
			this.$store.commit("ecommerce/setDetailsTab", event.index);
		},
		isActiveTab(tabName) {
			return this.tabs.indexOf(tabName) === this.$store.state.ecommerce.detailsTab;
		},
	},

	mounted() {
		if (this.tabs) {
			this.$store.commit("ecommerce/setTotalDetailsTabs", this.tabs?.length || 0);
		}
	},
});
</script>

<style lang="scss" scoped>
h2 {
	text-align: center;

	@include font-title-xl;
}

.details-container {
	margin: 0 auto;
}

:deep() {
	.tab-bar .tab-set {
		justify-content: center;

		@media screen and (max-width: $size-screen-desktop) {
			text-align: center;
			justify-content: flex-start;
		}
	}
}
</style>
